<template>
  <div style="zoom: 0.8">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("hardware", 1) }} {{ $t("device") }} {{ $tc("setting", 2) }}
        </div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("hardware", 2) }}
          {{ $tc("setting", 2) }} {{ $tc("incinematic") }}
        </div>
      </div>
      <div>
        <router-link
          v-if="$can('create', 'Hardware Settings')"
          variant="default"
          class="btn-blue"
          to="add-hardware-settings"
          >{{ $tc("add") }}</router-link
        >
        <button variant="default" class="btn-blue" @click="PingDevices()">
          {{ $t("Refresh") }}
        </button>
        <b-dropdown
          :text="filterButtonTitle"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item
            v-for="(status, statusIndex) in statuses"
            :key="statusIndex"
            v-on:click="filterStatus(status.status)"
            >{{ status.status }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex" style="gap: 15px; width: 500px">
        <div class="w-100">
          <b-form-input
            v-debounce:300="searchHardwareSettingList"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
        <div class="w-100">
          <multiselect
            v-model="cinemasSelected"
            :placeholder="'Cinema'"
            :options="Cinemas"
            @select="onSelectCinema($event)"
            @remove="onRemoveCinema($event)"
            selectLabel="Select"
            deselectLabel="✖"
            label="cine_name"
            track-by="cine_id"
            :multiple="false"
          ></multiselect>
        </div>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          :class="view == 'grid' ? 'active' : ''"
          v-on:click="viewType('grid')"
        ></button>
        <button
          class="btnj btn-listView"
          :class="view == 'list' ? 'active' : ''"
          v-on:click="viewType('list')"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="view == 'list'">
      <thead>
        <tr>
          <th class="text-left" style="width: 150px">
            <span class="pr-4">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'h_name'"
              @click="onSortValue('h_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('h_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('h_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />{{ $tc("hardware", 2) }} {{ $tc("setting", 2) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="hardwareSettingList.length > 0">
        <tr
          v-for="(hardwareSetting, hardwareSettingIndex) in hardwareSettingList"
          :key="hardwareSettingIndex"
        >
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <div class="text-center">
                <StatusDot
                  :status="
                    hardwareSetting.is_online == 'Y'
                      ? 'active'
                      : hardwareSetting.is_online == 'N' && 'inactive'
                  "
                />
              </div>
              <span
                class="edit-pen ml-2 blue-icon cursor-pointer"
                title="Edit"
                style="height: 16px; width: 16px"
                @click="
                  goToRoute(
                    '/cinema-manager/edit-hardware-settings',
                    hardwareSetting
                  )
                "
              ></span>
              <span
                class="icon-eye ml-2 blue-icon cursor-pointer"
                title="View"
                style="height: 16px; width: 16px"
                @click="
                  goToRoute(
                    '/cinema-manager/view-hardware-settings',
                    hardwareSetting
                  )
                "
              ></span>
              <span
                class="ml-2 cursor-pointer blue-icon"
                title="Archive"
                @click="
                  device_id = hardwareSetting.hs_id;
                  $bvModal.show('confirmation');
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#4682B4"
                  class="bi bi-archive"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                  />
                </svg>
              </span>
            </div>
          </td>

          <td>{{ hardwareSetting.hs_hardware_name }}</td>
          <!-- <td>
            <div class="d-flex align-items-center justify-content-end">
              <div class="text-center">
                <StatusDot
                  :status="
                    hardwareSetting.is_online == 'Y'
                      ? 'active'
                      : hardwareSetting.is_online == 'N' && 'inactive'
                  "
                />
              </div>
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Hardware Settings')"
                  @click="
                    goToRoute(
                      '/cinema-manager/edit-hardware-settings',
                      hardwareSetting
                    )
                  "
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/cinema-manager/view-hardware-settings',
                      hardwareSetting
                    )
                  "
                >
                  <span class="icon-eye"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    device_id = hardwareSetting.hs_id;
                    $bvModal.show('confirmation');
                  "
                >
                  <span class="icon-archive"></span>
                  {{ $t("Archive") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="2">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Box View -->
    <aside class="row" v-if="view == 'grid' && hardwareDeviceStatus.length > 0">
      <div
        class="col-md-3"
        v-for="(device, deviceIndex) in hardwareDeviceStatus"
        :key="deviceIndex"
      >
        <article class="device shadow">
          <div class="row">
            <article class="col">
              <aside class="d-flex align-items-center justify-content-between">
                <p class="device-title pr-3">
                  <span
                    :class="
                      device.is_online == 'Y'
                        ? 'device-status active'
                        : 'device-status inactive'
                    "
                    class="mr-2 pr-2"
                  />
                  {{
                    device.hs_hardware_name
                      ? device.hs_hardware_name
                      : "Unknown Device"
                  }}
                  <!-- <span
                    class="last-online ml-3"
                    v-if="device.last_online_date_time"
                  >
                    Last online
                    {{ getLastOnlineMinutes(device.last_online_date_time) }}
                  </span> -->
                </p>
                <div
                  class="d-flex align-items-center"
                  v-if="$can('update', 'Hardware Settings')"
                >
                  <b-dropdown right variant="edit" class="ml-4">
                    <b-dropdown-item
                      @click="
                        goToRoute(
                          '/cinema-manager/edit-hardware-settings',
                          device
                        )
                      "
                    >
                      <span class="edit-pen"></span>
                      {{ $t("edit") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        device_id = device.hs_id;
                        $bvModal.show('confirmation');
                      "
                    >
                      <span class="icon-archive"></span>
                      {{ $t("Archive") }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </aside>
            </article>
          </div>
          <div class="row py-2">
            <span class="last-online ml-3" v-if="device.last_online_date_time">
              Last online
              {{ getLastOnlineMinutes(device.last_online_date_time) }}
            </span>
          </div>
          <div class="row py-2">
            <span
              class="last-online ml-3 fs-12"
              style="color: green; font-weight: 500"
            >
              Last Active User: &nbsp;{{
                device.last_logged_user && device.last_logged_user
              }}
            </span>
          </div>
          <div class="row" v-if="true">
            <article class="col-md-4">
              <aside class="device-prop">
                <p class="property">CPU Usage</p>
                <p class="value">
                  {{
                    device.resource_usage_info &&
                    device.resource_usage_info.cpu.currentload
                      ? device.resource_usage_info.cpu.currentload + " %"
                      : "-"
                  }}
                </p>
              </aside>
            </article>
            <article class="col-md-4">
              <aside class="device-prop">
                <p class="property">RAM Usage</p>
                <p class="value">
                  {{
                    device.resource_usage_info &&
                    device.resource_usage_info.memory.used
                      ? device.resource_usage_info.memory.used
                      : "-"
                  }}/{{
                    device.resource_usage_info &&
                    device.resource_usage_info.memory.total
                      ? device.resource_usage_info.memory.total
                      : "-"
                  }}
                  GB
                </p>
              </aside>
            </article>
            <article class="col-md-4">
              <aside class="device-prop">
                <p class="property">Hard Disk Usage</p>
                <p class="value">
                  {{
                    device.resource_usage_info &&
                    device.resource_usage_info.disk.used
                      ? (
                          (device.resource_usage_info.disk.used /
                            device.resource_usage_info.disk.total) *
                          100
                        ).toFixed(MIN_FRACTION_DIGITS) + " %"
                      : "-"
                  }}
                </p>
              </aside>
            </article>
            <article class="col-md-12">
              <aside class="device-prop">
                <p class="property">Mac Address</p>
                <p class="value">
                  {{ device.mac_address ? device.mac_address : "-" }}
                </p>
              </aside>
            </article>
            <article class="col-md-12">
              <aside class="device-prop">
                <p class="property">Ipv6 Address</p>
                <p class="value">
                  {{ device.ipv6 ? device.ipv6 : "-" }}
                </p>
              </aside>
            </article>
            <article class="col-md-12">
              <aside class="device-prop">
                <p class="property">Ipv4 Address</p>
                <p class="value">
                  {{ device.ip_address ? device.ip_address : "-" }}
                </p>
              </aside>
            </article>
          </div>
        </article>
      </div>
    </aside>
    <aside
      class="row pt-5"
      v-if="view == 'grid' && hardwareDeviceStatus.length == 0"
    >
      <div class="w-100 text-center">
        <p v-if="selectedStatus != 'All'">No {{ selectedStatus }} Devices!</p>
        <p v-else>No Devices Found</p>
      </div>
    </aside>
    <b-modal
      id="confirmation"
      title="Archive Device"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">Are you sure you want to Archive this Device?</p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="ArchiveDevice"
        >
          Archive
        </button>
      </div>
    </b-modal>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      cinemasSelected: "",
      cinema_id: null,
      Cinemas: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",

      hardwareSettingList: [],
      hardwareDeviceStatus: [],

      gridView: true,
      listView: false,
      view: "grid",
      debounce: null,
      searchValue: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      device_id: null,

      filterButtonTitle: "Active",
      statuses: [
        { status: "Active" },
        { status: "Online" },
        { status: "Offline" },
        { status: "Archived" },
        { status: "All" },
      ],
      selectedStatus: "Active",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    this.getHardwareSettingList();
    this.getHardDevicesStatus();
    this.getviewingnumber();
    this.getCinemaList();
  },
  mounted() {},
  methods: {
    getCinemaList: function () {
      MasterService.GetCinemas({ cine_id: this.cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            if (data.Records && data.Records.length === 1) {
              this.cinemasSelected = data.Records[0];
              this.onSelectCinema(data.Records[0]);
            }
          } else {
            // Show Error Message
            this.$toasted.show(data.message);
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    onSelectCinema(cinemaObj) {
      this.cinemasSelected = cinemaObj;
      this.cinema_id = cinemaObj.cine_id;
      this.currentPage = 1;
      this.getHardwareSettingList();
      this.getHardDevicesStatus();
    },
    onRemoveCinema() {
      this.cinemasSelected = "";
      this.cinema_id = null;
      this.currentPage = 1;
      this.getHardwareSettingList();
      this.getHardDevicesStatus();
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status;
      this.selectedStatus = status;
      this.getHardwareSettingList();
      this.getHardDevicesStatus();
    },
    PingDevices() {
      CinemasService.PingDevices().then((response) => {
        console.log("PingDevices response", response);
      });
      setTimeout(() => this.getHardDevicesStatus(), 5000);
    },
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getHardwareSettingList(this.selectedid);
      this.getHardDevicesStatus();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getHardwareSettingList(this.selectedid);
        this.getHardDevicesStatus();
      } else {
        this.currentPage = event;
        this.getHardwareSettingList(this.selectedid);
        this.getHardDevicesStatus();
      }
    },

    ArchiveDevice() {
      CinemasService.ArchiveHarrdwareDevice(this.device_id)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.$bvModal.hide("confirmation");
            this.getHardDevicesStatus();
            this.getHardwareSettingList();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    searchHardwareSettingList: function (search) {
      this.getHardwareSettingList(1, search);
      this.getHardDevicesStatus();
    },
    // Saif
    getHardwareSettingList: function (page = undefined, search = undefined) {
      this.hardwareSettingList = [];
      let payload = {
        limit: this.perPage,
        currentPage: page ? page : this.currentPage,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderBy,
        status: this.selectedStatus,
        cinema_id: this.cinema_id || null,
      };
      CinemasService.GetHardwareSettigns(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.hardwareSettingList = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.hardwareSettingList = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getHardDevicesStatus: function () {
      this.hardwareDeviceStatus = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderBy,
        status: this.selectedStatus,
        cinema_id: this.cinema_id || null,
      };
      CinemasService.GetHardwareDevicesStatus(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.data.data.length > 0) {
            console.log(" data.data.data", data.data.data);
            this.hardwareDeviceStatus = data.data.data;
          } else {
            this.hardwareDeviceStatus = [];
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function (path, item) {
      const { hs_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: hs_id,
        },
      });
    },
    getLastOnlineMinutes(last_online_date_time) {
      var startDate = moment(last_online_date_time).toDate();
      var endDate = moment.utc().toDate();
      var diff = endDate.getTime() - startDate.getTime();
      var hours = Math.floor(diff / 1000 / 60 / 60);
      diff -= hours * (1000 * 60 * 60);
      var minutes = Math.floor(diff / 1000 / 60);
      diff -= minutes * (1000 * 60);
      var seconds = Math.floor(diff / 1000);

      if (hours < 0) hours = hours + 24;

      if (hours > 24) {
        return moment(last_online_date_time, "YYYY-MM-DD HH:mm:ss").fromNow();
      } else {
        return (
          (hours <= 9 ? "0" : "") +
          hours +
          " hrs" +
          ": " +
          (minutes <= 9 ? "0" : "") +
          minutes +
          " mins" +
          " ago"
        );
      }
    },

    viewType: function (viewType) {
      if (viewType == "grid") {
        this.gridView = true;
        this.listView = false;
        this.view = "grid";
      } else if ((viewType = "list")) {
        this.listView = true;
        this.view = "list";
        this.gridView = false;
      }
    },
  },
};
</script>

<style>
.device-title {
  font-size: 20px !important;
}
.shadow {
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/HardwaresComponents/hardwareSettings.vue